/* CRO-002: keep the existing WhatsApp launcher above Maker's mobile buy bar. */
(function (root) {
  'use strict';
  function clearance(heights, mobile) {
    if (!mobile) return 0;
    return Math.ceil(Math.max(0, ...heights.filter(n => Number.isFinite(n) && n > 0)));
  }
  if (typeof module !== 'undefined' && module.exports) module.exports = { clearance };
  if (!root.document || root.__tlStickyClearance) return;
  root.__tlStickyClearance = true;
  const media = root.matchMedia('(max-width: 767px)');
  const observed = new WeakSet();
  let scheduled = false;
  function update() {
    scheduled = false;
    const heights = Array.from(document.querySelectorAll('.product-buy-buttons--drawer[aria-hidden="false"]'))
      .filter(el => root.getComputedStyle(el).display !== 'none')
      .map(el => el.getBoundingClientRect().height);
    const value = clearance(heights, media.matches);
    document.documentElement.style.setProperty('--tl-sticky-clearance', `${value}px`);
    document.documentElement.toggleAttribute('data-tl-sticky-visible', value > 0);
  }
  function queue() {
    if (!scheduled) { scheduled = true; root.requestAnimationFrame(update); }
  }
  const resize = root.ResizeObserver ? new ResizeObserver(queue) : null;
  const visibility = new MutationObserver(queue);
  function bind() {
    document.querySelectorAll('.product-buy-buttons--drawer').forEach(el => {
      if (observed.has(el)) return;
      observed.add(el);
      resize?.observe(el);
      visibility.observe(el, { attributes: true, attributeFilter: ['aria-hidden'] });
    });
    queue();
  }
  media.addEventListener('change', queue);
  root.addEventListener('resize', queue, { passive: true });
  root.addEventListener('pageshow', bind);
  document.addEventListener('shopify:section:load', bind);
  document.addEventListener('shopify:section:unload', queue);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', bind, { once: true });
  else bind();
})(typeof window !== 'undefined' ? window : globalThis);
